import React, { useState } from "react";
import requestDrop from "../../../assets/requestDrop.png";
import Loader from "../../../components/loader/Loader";
import moment from "moment";
import styles from "../request.module.css";
import { AiOutlineClose } from "react-icons/ai";
import Empty from "../../../assets/illustration_empty_content.svg";

const Donated = ({ isLoading, requestData }) => {
  const [donatedId, setDonatedId] = useState(false);

  const handleView = (e) => {
    setDonatedId(e);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <ul className={styles.unorderedList}>
          {requestData.length > 0 ? (
            requestData
              ?.slice(0)
              .reverse()
              .filter((requestData) => requestData.status === "accepted")
              .map(
                ({
                  updatedAt,
                  patientLocation,
                  pintOfBlood,
                  _id,
                  index,
                  firstname,
                  lastname,
                  phone,
                  bloodType,
                  country,
                  city,
                  email,
                  state,
                  status,
                }) => (
                  <>
                    <li
                      className={`${styles.list} justify-between shadow rounded hover:bg-red-50 lg:px-4 px-2 py-2`}
                      key={index}
                      onClick={() => {
                        handleView(_id);
                      }}
                    >
                      {/* Date Divider */}
                      <div className="flex gap-4 items-center">
                        <div className={`${styles.date} items-center`}>
                          <div
                            className={`${styles.month} lg:text-3xl text-2xl`}
                          >
                            {moment(updatedAt).format("MMM")}
                          </div>
                          <div className={styles.monthDate}>
                            {moment(updatedAt).format("D")}
                          </div>
                        </div>

                        <div className={`${styles.requestDetails} flex `}>
                          <div className={styles.requestTitle}>
                            {patientLocation}
                          </div>
                          <div className={styles.requestPint}>
                            <img
                              className={styles.drop}
                              src={requestDrop}
                              alt="drop"
                            />{" "}
                            <span className={styles.pintLevel}>
                              {pintOfBlood} pint of blood
                            </span>
                          </div>
                        </div>
                      </div>
                      <span
                        className={`${styles.greenSide} first-letter:uppercase`}
                      >
                        {status}
                      </span>
                    </li>
                    {donatedId === _id && (
                      <>
                        <div
                          className="fixed w-screen h-screen z-[100] top-0 left-0 bottom-0 right-0 overflow-x-hidden overflow-y-hidden bg-[black]/50"
                          tabIndex="-1"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="p-3">
                            <div className="rounded-lg sm:w-4/5 lg:w-3/5 relative my-20 lg:my-[112px] mx-auto p-4 bg-[#f6655f] text-current">
                              <div className="">
                                <button
                                  onClick={() => setDonatedId(null)}
                                  className="absolute top-4 r-4 text-white z-[3] cursor-pointer"
                                >
                                  <AiOutlineClose color="white" size={32} />
                                </button>
                                <div className="flex justify-center items-center rounded-3xl mx-auto flex-col py-6">
                                  <h3 className="font-poppins font-normal text-xl text-white border-b border-[#f6655f] mb-6">
                                    Confirm Donation
                                  </h3>

                                  <div className="flex h-full justify-center items-center box-border font-poppins">
                                    <div className="grid grid-cols-2 gap-x-3 lg:gap-x-5 box-border lg:px-8">
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        First name:
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        {firstname}
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        Last name:
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        {lastname}
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        Phone number:
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        {phone}
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        Blood Type:
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        {bloodType}
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        Country:
                                      </p>
                                      <p
                                        className={`$'font-normal text-base box-border text-white my-2.5' uppercase`}
                                      >
                                        {country}
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        Home Address:
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        {patientLocation}
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        Amount of Blood:
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        {pintOfBlood} pint of Blood
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        State:
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        {state}
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        City/Town:
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        {city}
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        Email:
                                      </p>
                                      <p className="font-normal text-base box-border text-white my-2.5">
                                        {email}
                                      </p>
                                    </div>
                                  </div>

                                  <hr />

                                  <div className="flex justify-center items-center w-full mt-6">
                                    <button
                                      // onClick={UpdateStatus}
                                      className="cursor-pointer w-32 h-11 text-white mr-6 text-lg font-bold font-poppins hover:border hover:text-[#F54B46] hover:bg-white hover:border-white hover:rounded-2xl"
                                    >
                                      Donated
                                    </button>
                                    <button
                                      onClick={() => setDonatedId(null)}
                                      className="cursor-pointer border w-[139px] h-11 bg-transparent rounded-[45px] text-[#F1908C] hover:bg-white hover:text-[#F54B46]"
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )
              )
          ) : (
            <div className="wrapper p-6">
              <div className="empty py-16 px-4 flex flex-col justify-center items-center h-full">
                <span className="">
                  <img src={Empty} alt="Emptty data icon" srcset="" />
                </span>
                <h5 className=" text-xl font-bold text-gray-600 my-3 text-center">
                  You do not have any completed blood donation
                </h5>
              </div>
            </div>
          )}
        </ul>
      )}
    </>
  );
};

export default Donated;
